var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapClasss },
    [
      _vm.type === "textarea"
        ? _c("textarea", {
            ref: "textarea",
            staticClass: "mku-textarea",
            style: _vm.inputStyle,
            attrs: {
              rows: _vm.rows,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              readonly: _vm.readonly
            },
            domProps: { value: _vm.currentValue },
            on: {
              input: _vm.handleInput,
              focus: _vm.handleFocus,
              blur: _vm.handleBlur,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleEnter($event)
              }
            }
          })
        : [
            _c("input", {
              ref: "input",
              class: _vm.inputClasss,
              style: _vm.inputStyle,
              attrs: {
                type: _vm.type,
                placeholder: _vm.placeholder,
                disabled: _vm.disabled,
                readonly: _vm.readonly
              },
              domProps: { value: _vm.currentValue },
              on: {
                input: _vm.handleInput,
                focus: _vm.handleFocus,
                blur: _vm.handleBlur,
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleEnter($event)
                }
              }
            }),
            _vm._v(" "),
            _vm.isClearable
              ? _c(
                  "i",
                  {
                    staticClass: "mku-icon mku-input__clear",
                    on: { click: _vm.handleClear }
                  },
                  [_vm._v("\n      \n    ")]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }